import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { HubOverviewState } from './hub-overview.state';
import { HubOverviewInitialState, HubOverviewLoad, HubOverviewUpdate } from './hub-overview.actions';
import { HubOverview } from '../../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common/models';

@Injectable({ providedIn: 'root' })
export class HubOverviewFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(HubOverviewState.getLoaded);
  hubName$: Observable<string> = this.store.select(HubOverviewState.getName);
  overview$: Observable<HubOverview> = this.store.select(HubOverviewState.getOverview);

  constructor(private store: Store) {}

  loadAll(hubId: number): void {
    this.store.dispatch(new HubOverviewLoad(hubId));
  }

  updateHubOverview(hubData: HubOverview): void {
    this.store.dispatch(new HubOverviewUpdate(hubData));
  }

  setInitialState(): void {
    this.store.dispatch(new HubOverviewInitialState());
  }
}
